/* @flow */

import Immutable from 'immutable';
import { bindSelectors, memoizeSelectors } from './selectors';

const Selectors = {
  hasViewLoaded(state: Immutable.Map, viewId: string): boolean {
    return state.getIn(['views', viewId], null) !== null;
  },
  getViewId(state: Immutable.Map): string {
    return state.get('activeViewId', 'default');
  },
  getTitle(state: Immutable.Map): string {
    const viewId = state.get('activeViewId', 'default');
    return state.getIn(['views', viewId, 'title'], null);
  },
  getDefaultViewport(state: Immutable.Map): string {
    const viewId = state.get('activeViewId', 'default');
    return state.getIn(['views', viewId, 'defaultViewport']);
  },
  getStyleUrl(state: Immutable.Map): string {
    const viewId = state.get('activeViewId', 'default');
    return state.getIn(['views', viewId, 'styleURL'], null);
  },
  getMaxBounds(state: Immutable.Map): Immutable.List {
    const viewId = state.get('activeViewId', 'default');
    return state.getIn(['views', viewId, 'maxBounds'], Immutable.List());
  },
  getAttributions(state: Immutable.Map): Immutable.List {
    const viewId = state.get('activeViewId', 'default');
    return state.getIn(['views', viewId, 'attributions'],  Immutable.List());
  },
  getInteractiveSources(state: Immutable.Map): Immutable.Map {
    const viewId = state.get('activeViewId', 'default');
    return state.getIn(['views', viewId, 'interactiveSources'],  Immutable.Map());
  },
  getSearchKeys(state: Immutable.Map): Immutable.List {
    const viewId = state.get('activeViewId', 'default');
    return state.getIn(['views', viewId, 'search', 'keys'],  Immutable.List());
  },
  getSearchSuggestions(state: Immutable.Map): Immutable.List {
    const viewId = state.get('activeViewId', 'default');
    return state.getIn(['views', viewId, 'search', 'suggestions'],  Immutable.List());
  },
  getSearchDatasets(state: Immutable.Map): Immutable.List {
    const viewId = state.get('activeViewId', 'default');
    return state.getIn(['views', viewId, 'search', 'datasets'],  Immutable.List());
  },
  getSearchOptions(state: Immutable.Map): Immutable.Map {
    const viewId = state.get('activeViewId', 'default');
    return state.getIn(['views', viewId, 'search', 'options'],  Immutable.Map());
  },
  isMenuVisible(state: Immutable.Map): boolean {
    return state.get('menuVisible');
  },
  getMenuSettings(state: Immutable.Map): Immutable.Map {
    const viewId = state.get('activeViewId', 'default');
    return state.getIn(['views', viewId, 'menu'],  Immutable.Map());
  },
};

const UnboundViewSelectors = memoizeSelectors(Selectors);
const ViewSelectors = bindSelectors('view', UnboundViewSelectors);

export {
  ViewSelectors,
  UnboundViewSelectors
};
